import React from 'react'

export const ProfileBillingTableRow = () => {
    return (

        <div className='row align-items-center 
        justify-content-center py-1 brand-yellow-box-shadow'>
            <div className='col-md-3'>
                <p>Carlsen</p>
            </div>
            <div className='col-md-6'>
                Dev-03023300-3
            </div>
            <div className='col-md-3'>
                90.00
            </div>
        </div>
    )
}